import React, { useState } from "react";
import styled from "styled-components";

const MessageError = ({ messageError = undefined }) => {
  return (
    <>
      {messageError && <MessageErrorStyled>{messageError}</MessageErrorStyled>}
    </>
  );
};

const MessageErrorStyled = styled.div`
  font-size: 0.85em;
  margin-top: 5px;
  color: red;
`;

export default MessageError;
